import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://admin.vkksu.com';

// Створюємо екземпляр axios з базовою конфігурацією
export const axiosInstance = axios.create({
  baseURL: API_URL,
  // timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Додаємо інтерцептор для автоматичного перенаправлення API запитів
axiosInstance.interceptors.request.use(
  (config) => {
    // Keep production traffic on the API host even if an old build has a wrong env value.
    if (typeof window !== 'undefined' && config.baseURL !== API_URL) {
      const currentHost = window.location.hostname;
      if (currentHost === 'www.vkksu.com' || currentHost === 'vkksu.com') {
        config.baseURL = API_URL;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Додаємо інтерцептор для обробки помилок та HTML відповідей
axiosInstance.interceptors.response.use(
  (response) => {
    // Check if we received HTML instead of JSON (nginx serving static files)
    if (typeof response.data === 'string' && response.data.includes('<html>')) {
      const originalRequest = response.config;
      const apiUrl = new URL(originalRequest.url || '', originalRequest.baseURL || API_URL).toString();
      
      return fetch(apiUrl, {
        method: originalRequest.method?.toUpperCase() || 'GET',
        headers: {
          'Authorization': String(originalRequest.headers.Authorization || ''),
          'Content-Type': 'application/json',
        },
        body: originalRequest.data ? JSON.stringify(originalRequest.data) : undefined,
        credentials: 'include',
      }).then(res => res.json()).then(data => ({ ...response, data }));
    }
    return response;
  },
  (error) => {
    // Можна додати глобальну обробку помилок
    return Promise.reject(error);
  }
);

// Додаємо інтерцептор для додавання токена авторизації
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
